export default "__VITE_ASSET__9e88cdef__"